import { Component } from '@angular/core';

@Component({
  selector: 'ui-nav-thumbnail',
  templateUrl: './nav-thumbnail.component.html'
})
export class NavThumbnailComponent {

}